import React from "react";
import {IconProps} from "./types";

export const HomeIcon = ({fill}: IconProps) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.207 1.29297C11.0194 1.10543 10.7651 1 10.4999 1C10.2678 1 10.0441 1.08073 9.86614 1.22656L9.79289 1.29297L3.57024 7.51465L1.79289 9.29297C1.40237 9.68349 1.40237 10.3165 1.79289 10.707C2.18342 11.0976 2.81643 11.0976 3.20696 10.707L4.49992 9.41477V16C4.49992 17.1046 5.39535 18 6.49992 18H7.49992C8.05221 18 8.49992 17.5523 8.49992 17V14C8.49992 13.4477 8.94764 13 9.49992 13H11.4999C12.0522 13 12.4999 13.4477 12.4999 14V17C12.4999 17.5523 12.9476 18 13.4999 18H14.4999C15.6045 18 16.4999 17.1046 16.4999 16V9.41477L17.7929 10.707L17.8691 10.7754C18.2618 11.0957 18.8408 11.0731 19.207 10.707C19.5731 10.3409 19.5957 9.76191 19.2753 9.36914L19.207 9.29297L17.4296 7.51465L11.207 1.29297Z"
        fill={fill || "#6B7280"}
      />
    </svg>
  );
};
